import styled from 'styled-components'

export const StyledPageTitle = styled.title`
  display: inline;
`
